export const PROXY_ORIGIN_IP_HEADER = 'x-forwarded-for'

export interface HttpRequest {
  headers?: Record<string, string>
}

export const getOriginalClientIP = (req?: HttpRequest) => {
  const originalClientIP =
    req?.headers?.[PROXY_ORIGIN_IP_HEADER] || req?.headers?.['X-Forwarded-For']

  if (originalClientIP) return originalClientIP.split(',')[0].trim()

  return originalClientIP
}

export const passThroughRequestHeaders = (req?: HttpRequest) => {
  const ip = getOriginalClientIP(req)

  console.log('[passThroughRequestHeaders] original_client_ip', ip)

  const userAgent = req?.headers?.['user-agent'] || req?.headers?.['User-Agent']

  return {
    [PROXY_ORIGIN_IP_HEADER]: ip,
    'user-agent': userAgent,
    'User-Agent': userAgent,
  }
}
